<template>
  <div></div>
</template>
<script>
import L from 'leaflet'
import {thousandsSeparator} from '../util'
import constants from '../constants'

export default {
  name: 'map-legend',
  props: {
    colorScale: null,
    gradients: null,
    title: {
      type: String,
      title: ''
    },
    min: null,
    max: null,
    position: {
      type: String,
      default: 'topright'
    }
  },
  data: function () {
    return {
      truncationIndicator: true
    }
  },
  mounted () {
    const {colorScale, gradients, title, min, max, position, convertLegendValues} = this

    this.mapObject = L.control({
      position: position
    })
    this.mapObject.onAdd = function (map) {
      this._div = L.DomUtil.create('div', 'info') // create a div with a class 'info'
      this.update({min, max, colorScale, title, gradients, convertLegendValues})
      return this._div
    }

    this.mapObject.update = function ({min, max, colorScale, title, gradients, convertLegendValues}) {
      let missingValueEntry = `<div class="geostats-legend"><div><div class="geostats-legend-block" style="background-color: ${constants.UNAVAIL_COLOUR}"></div> ${constants.UNAVAIL}</div></div>`
      this._div.innerHTML = '<div id="legend-title">' +
        title +
        '</div>' +
        missingValueEntry +
        gradients.getHtmlLegend(colorScale, '', null, convertLegendValues, null, 'distinct')
    }

    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }
  },
  methods: {
    deferredMountedTo (parent) {
      this.parent = parent
      this.mapObject.addTo(parent)
    },
    convertLegendValues (value) {
      if (typeof value === 'string') {
        // legend values (ranges!) are formatted as strings
        value = Number(value)
      }
      // if (this.$store.state.selectedNormalization !== 'no') {
      //   this.truncationIndicator = false
      // }
      return thousandsSeparator(value, 3, 'en', this.truncationIndicator)
    }
  },
  watch: {
    min () {
      this.mapObject.update(this)
    },
    max () {
      this.mapObject.update(this)
    }
  },
  beforeDestroy () {
    if (this.parent) {
      this.parent.removeLayer(this.mapObject)
    }
  }
}
</script>
<style>
@import '../assets/css/legend.css';
</style>



// WEBPACK FOOTER //
// src/components/Legend.vue